import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2acc40f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pause-resumed-modal__text mb-2" }, " Период паузы завершён, и ваша подписка PRO была автоматически продлена. ", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pause-resumed-modal__text mb-2" }, " Оплата за следующий период успешно списана с привязанной карты. ", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "p-3 mb-2 rounded pause-resumed-modal__important" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "mb-2" }, "Вам снова доступны все возможности PRO:"),
  /*#__PURE__*/_createElementVNode("ul", { class: "mb-0 pause-resumed-modal__list" }, [
    /*#__PURE__*/_createElementVNode("li", null, "безлимит учеников"),
    /*#__PURE__*/_createElementVNode("li", null, "интерактивная онлайн-доска"),
    /*#__PURE__*/_createElementVNode("li", null, "звонки")
  ])
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "pause-resumed-modal__text mb-2" }, " Приятной работы в Finch! ", -1))

import { ref } from 'vue';
import TariffNotificationModal from '../../TariffNotificationModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PauseResumedModal',
  emits: ["hidden"],
  setup(__props, { expose: __expose, emit: __emit }) {

const emit = __emit;

const modalRef = ref<InstanceType<typeof TariffNotificationModal>>();

function showModal() {
    modalRef.value?.show();
}

function hideModal() {
    modalRef.value?.hide();
}

__expose({
    show: showModal,
    hide: hideModal,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(TariffNotificationModal, {
    ref_key: "modalRef",
    ref: modalRef,
    title: "Подписка PRO успешно возобновлена",
    "max-width": 450,
    onHidden: _cache[0] || (_cache[0] = ($event: any) => (emit('hidden')))
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _hoisted_3,
      _hoisted_4
    ]),
    footer: _withCtx(() => []),
    _: 1
  }, 512))
}
}

})